import ImageEditor from "./image-editor.vue";
import ImageEditorRef from "./image-editor";

export { ImageEditor, ImageEditorRef };
export interface ImageEditorRotateEvent {
	canvasData: Cropper.CanvasData;
	clockWise: boolean;
}
export interface ImageEditorFlipEvent {
	canvasData: Cropper.CanvasData;
	axis: ImageEditorFlipAxis;
}

export enum ImageEditorFlipAxis {
	horizontal = "scaleX",
	vertical = "scaleY"
}
